module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-side-menu"
  }, [_c('el-menu', {
    staticClass: "menu",
    attrs: {
      "default-active": _vm.$route.path,
      "background-color": "rgb(234, 238, 241)",
      "active-text-color": "#189bff",
      "text-color": "#888",
      "router": "router"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "/school/compete/activities"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-on"
  }), _c('span', [_vm._v("比赛信息")])]), _c('el-menu-item', {
    attrs: {
      "index": "/school/compete/entries"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-on"
  }), _c('span', [_vm._v("比赛审批")])]), _c('el-menu-item', {
    attrs: {
      "index": "/school/train/entries"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-on"
  }), _c('span', [_vm._v("培训审批")])]), _c('el-menu-item', {
    attrs: {
      "index": "/school/research/projects"
    }
  }, [_c('i', {
    staticClass: "el-icon-star-on"
  }), _c('span', [_vm._v("教改审批")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab7316f2","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/schools/common/SideMenu.vue
// module id = 577
// module chunks = 85